import { TableCellContentProps } from "ds/components/Table/Row/CellContent";
import TableCellGroup from "ds/components/Table/Row/CellGroup";

import { RenderGroupRowCellProps } from "../Content";
import usePersonalSettingsSpacesTableGroupsStore from "../../../usePersonalSettingsSpacesGroupsStore";
import { isSpaceActionsGroup } from "../../../helpers";
import PersonalSettingsSpacesTableCell from "../../Cell";

type PersonalSettingsSpacesGroupCellProps = RenderGroupRowCellProps &
  Pick<TableCellContentProps, "children" | "role">;

const PersonalSettingsSpacesGroupCell = ({
  cellId,
  isFirst,
  children,
  isGroupOpen,
  role,
  row,
}: PersonalSettingsSpacesGroupCellProps) => {
  const { toggleGroupMeta } = usePersonalSettingsSpacesTableGroupsStore();

  return (
    <PersonalSettingsSpacesTableCell id={cellId} role={role}>
      <TableCellGroup
        isActive={isFirst}
        onPress={() => toggleGroupMeta(isSpaceActionsGroup(row) ? row.spaceID : "")}
        isGroupOpen={isGroupOpen}
        title="Open group"
      >
        {children}
      </TableCellGroup>
    </PersonalSettingsSpacesTableCell>
  );
};

export default PersonalSettingsSpacesGroupCell;
